module.exports = __webpack_public_path__ + "static/media/bj.b6387659.svg";